<template>
    <div class="div">
        <button class="button is-small" :class="{'bold' : isFilled }" @click="openModal" style="min-width: 55px;">
            {{ label }}
        </button>
        <div class="modal" :class="{'is-active': isActive }">
            <div class="modal-background" @click="isActive = !isActive"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Remarks:</p>
                    <button class="delete" aria-label="close" @click="isActive = !isActive"></button>
                </header>
                <section class="modal-card-body">
                    <input class="input" type="text" v-model="carData.query.remarks"/>
                </section>
                <footer class="modal-card-foot">
                    <button class="button is-primary"  @click="saveRemarks()">Save</button>
                    <button class="button"  @click="isActive = !isActive">Close</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import apiInspections from './../../../api/apiInspections'
    import apiCars from './../../../api/apiCars'
    import moment from 'moment'
    export default {
        props:['car'],
        components: {

        },
        data () {
            return {
                isActive: false,
                label:this.car.remarks === null ? '---' : 'YES',
                carData:{
                    id: this.car.id,
                    query: {
                        remarks: this.car.remarks,
                    }
                }
            }
        },
        methods: {
            saveRemarks() {
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.label = 'YES'
                        this.isActive = false
                    })
                    .catch(error => console.log(error))
            },
            openModal() {
                this.isActive = !this.isActive
            }
        },
        computed: {
            isFilled() {
                if (this.carData.query.remarks !== null){
                    return  true;
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/RemarksColumn.vue